export default __webpack_public_path__ + "static/media/hm-png-img.e6d66abe.webp";